import React from 'react';

const UserBadges = ({ user, size = 'small' }) => {
  const badges = [];

  // Insignia de torneo marcial completado
  if (user.torneo_marcial_completado) {
    badges.push({
      id: 'martial_tournament',
      title: 'Maestro Marcial - Completó el Torneo Marcial',
      image: '/assets/badges/martial-tournament-32.png',
      className: 'badge-martial-tournament'
    });
  }

  // Insignia de 10 combates IA ganados
  if (user.combates_ia_ganados >= 10) {
    badges.push({
      id: 'combat_ia_10',
      title: `Vencedor IA - Ganó ${user.combates_ia_ganados} combates contra IA`,
      image: '/assets/badges/combat-ia-32.png',
      className: 'badge-combat-ia'
    });
  }

  // Insignia de vencer a 4° Dan (SABON NIM)
  if (user.combate_4dan_ganado) {
    badges.push({
      id: 'combat_4dan',
      title: 'Vencedor 4° Dan - Derrotó a Sabon Nim',
      image: '/assets/badges/combat-4dan-32.png',
      className: 'badge-combat-4dan'
    });
  }

  // Insignia de vencer a 7° Dan (MASTER)
  if (user.combate_maestro_ganado) {
    badges.push({
      id: 'combat_maestro',
      title: 'Vencedor 7° Dan - Derrotó al Master',
      image: '/assets/badges/combat-maestro-32.png',
      className: 'badge-combat-maestro'
    });
  }

  // Insignia de vencer a 9° Dan (GRAN MASTER)
  if (user.combate_granmaster_ganado) {
    badges.push({
      id: 'combat_granmaster',
      title: 'Vencedor 9° Dan - Derrotó al Gran Master',
      image: '/assets/badges/combat-granmaster-32.png',
      className: 'badge-combat-granmaster'
    });
  }

  if (badges.length === 0) return null;

  return (
    <div className={`user-badges ${size}`}>
      {badges.map(badge => (
        <span
          key={badge.id}
          className={`badge ${badge.className}`}
          title={badge.title}
        >
          <img 
            src={badge.image} 
            alt={badge.title}
            className="badge-image"
            onError={(e) => {
              // Fallback a emoji si la imagen no carga
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'inline';
            }}
          />
          <span className="badge-emoji" style={{ display: 'none' }}>
            {badge.id === 'martial_tournament' ? '🏆' :
             badge.id === 'combat_ia_10' ? '🤖' :
             badge.id === 'combat_4dan' ? '🥋' :
             badge.id === 'combat_maestro' ? '⚡' :
             badge.id === 'combat_granmaster' ? '👑' : '🏆'}
          </span>
        </span>
      ))}
    </div>
  );
};

export default UserBadges;